/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import i18n from 'i18n-react';
import Baggage from '../baggage/Baggage';
import _ from 'lodash';

import './FlightDetailsModal.css';
import FeatureService from '../../../services/feature/FeatureService';
import Features from '../../../const/Features';
import { isFromCallcenter } from '../../../services/queryService/QueryService.js';
import PointsPlusMoneyDetailModal from './PointsPlusMoneyDetailModal.jsx';
import moment from 'moment';

const propTypes = {
  id: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  classType: PropTypes.string,
  isDeparture: PropTypes.bool,
  flightGroup: PropTypes.arrayOf(
    PropTypes.shape({
      flightNumber: PropTypes.number.isRequired,
      origin: PropTypes.string.isRequired,
      originAirportName: PropTypes.string.isRequired,
      destination: PropTypes.string.isRequired,
      destinationAirportName: PropTypes.string.isRequired,
      departureTime: PropTypes.string.isRequired,
      departureDate: PropTypes.string.isRequired,
      arrivalTime: PropTypes.string.isRequired,
      arrivalDate: PropTypes.string.isRequired,
      operatingCarrier: PropTypes.string.isRequired,
      throughFlight: PropTypes.bool.isRequired,
      hasExchangeAirport: PropTypes.bool.isRequired
    })
  ),
  baggage: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      quantity: PropTypes.number,
      weight: PropTypes.number
    })
  ),
  cabinCategory: PropTypes.string,
  onSelect: PropTypes.func,
  featureShowModalSelectionFlightsToggle: PropTypes.bool,
  fareDeparture: PropTypes.object,
  isCallcenterEnabled: PropTypes.bool,
  flight: PropTypes.object,
  prices: PropTypes.object
};

const defaultProps = {
  flightGroup: [],
  isDeparture: true,
  isCabinCategoryEnabled: false,
  onSelect: null,
  flight: null,
  prices: []
};

class FlightDetailsModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      featureShowModalSelectionFlightsToggle: this.props.featureShowModalSelectionFlightsToggle,
      featureCabinInfoInSearchBusiness: false,
      onlyPointsIsChecked: true
    };
    this.callbackFinalizeGetPoints = this.callbackFinalizeGetPoints.bind(this);
    this.callbackSelectPointsPlusMoney = this.callbackSelectPointsPlusMoney.bind(this);
  }

  componentWillMount() {
    FeatureService.isFeatureEnabled(Features.BUSINESS_WITH_MAJOR_CABIN).then(isEnableCabinInfo => {
      if (isEnableCabinInfo) {
        this.setState({
          featureCabinInfoInSearchBusiness: isEnableCabinInfo
        });
      }
    });
  }
  componentWillReceiveProps(nextProps) {
    let featureShowModalSelectionFlightsToggle = nextProps.featureShowModalSelectionFlightsToggle;
    if (
      featureShowModalSelectionFlightsToggle !== this.props.featureShowModalSelectionFlightsToggle
    ) {
      this.setState({
        featureShowModalSelectionFlightsToggle: featureShowModalSelectionFlightsToggle
      });
    }
  }

  getFormatedDateOrOfFlight(date) {
    if (date !== i18n.translate('components.flightDetailsModal.ofFlight')) {
      return `${Moment(date, 'DD/MM/YYYY').format('ddd,')} ${Moment(date, 'DD/MM/YYYY').format(
        'D MMM'
      )}`;
    } else {
      return date;
    }
  }

  renderBaggageInfo(category, index) {
    const mdSize = 4;
    const xsSize = 12;

    let baggageInfo = _.filter(this.props.baggage, ['category', category])[0];
    return (
      <Col
        key={`${index}-${category}`}
        xs={xsSize}
        md={mdSize}
        className="FlightDetailsModal__bag text-center">
        <div className={`FlightDetailsModal__${category.toLowerCase()}`}>
          <Baggage
            id={`baggageInfoFlight-${index}-${category}`}
            quantity={_.get(baggageInfo, 'quantity', 0)}
            weight={_.get(baggageInfo, 'weight', 0)}
          />
        </div>
      </Col>
    );
  }

  renderFlightsGrid() {
    return this.props.flightGroup.map((flight, index) => {
      let firstFlight = false;
      let lastFlight = false;
      if (index === 0) {
        firstFlight = true;
        if (index === this.props.flightGroup.length - 1) {
          lastFlight = true;
        }
      } else if (index === this.props.flightGroup.length - 1) {
        lastFlight = true;
      }

      const hasExchangeAirport = this.props.flightGroup[index + 1]
        ? this.props.flightGroup[index + 1].hasExchangeAirport
        : flight.hasExchangeAirport;
      return (
        <div key={index}>
          <Row className="FlightDetailsModal__flight">
            <Col xs={12} md={8} className="FlightDetailsModal__flight--firstCol">
              {this.renderFlight(firstFlight, lastFlight, flight)}
            </Col>
            {this.renderCabinBody(index)}
          </Row>
          {this.renderThroughFlight(hasExchangeAirport, lastFlight, index)}
        </div>
      );
    });
  }

  renderCabinBody(index) {
    return this.renderBaggageInfo(this.props.cabinCategory, index);
  }

  renderFlightHeader() {
    return (
      <Row className="FlightDetailsModal__flightHeader">
        <Col md={8} sm={12} className="FlightDetailsModal__flightHeader--col">
          {i18n.translate('components.flightDetailsModal.details')}
        </Col>
        <Col md={4} xsHidden className="FlightDetailsModal__flightHeader--col--empty" />
      </Row>
    );
  }

  renderCabinProduct(flightNumber) {
    if (this.state.featureCabinInfoInSearchBusiness) {
      if (this.props.fareDeparture[flightNumber].cabinProduct !== 'C') {
        return (
          <Row className="FlightDetailsModalBusiness">
            <i className="FlightDetailsModalBusiness__throughFlight--icon icon-error-outline" />
            <p>{i18n.translate(`components.flightDetailsModal.messageCabinTypeEconomy`)}</p>
          </Row>
        );
      } else {
        return (
          <Row className="FlightDetailsModalBusiness">
            <i className="FlightDetailsModalBusiness__throughFlight--icon icon-error-outline" />
            <p>{i18n.translate(`components.flightDetailsModal.messageCabinTypeBusiness`)}</p>
          </Row>
        );
      }
    }
  }

  renderFlight(firstFlight, lastFlight, flight) {
    return (
      <div>
        <Row className="FlightDetailsModal vertical-middle-row">
          <Col xs={1} className="FlightDetailsModal__verticalLine vertical-middle-col" />
          <Col xs={12} className="FlightDetailsModal__leg vertical-middle-col">
            {this.renderFlightLine(
              flight.departureTime,
              flight.departureDate,
              `${flight.originAirportName} (${flight.origin})`,
              null,
              firstFlight,
              flight,
              1
            )}

            {this.renderFlightLine(
              '9h50',
              i18n.translate('components.flightDetailsModal.ofFlight'),
              `${i18n.translate('components.flightDetailsModal.flight')} ${flight.operatingCarrier
              } ${flight.flightNumber}`,
              flight.marketingCarrier,
              false,
              flight,
              0
            )}

            {this.renderFlightLine(
              flight.arrivalTime,
              flight.arrivalDate,
              `${flight.destinationAirportName} (${flight.destination})`,
              null,
              lastFlight,
              flight,
              1
            )}
          </Col>
        </Row>
        {this.renderCabinProduct(flight.flightNumber)}
      </div>
    );
  }

  renderFlightLine(time, date, airportName, companyLogo, isLegBegginingOrEnd, flight) {
    const darkBlue = isLegBegginingOrEnd ? '--darkBlue' : '';
    return (
      <Row
        className={`FlightDetailsModal__line vertical-middle-row ${darkBlue ? `FlightDetailsModal__line${darkBlue}` : ''
          }`}>
        {this.renderCircle(darkBlue, companyLogo)}
        <Col xs={3} md={3} lg={2} className="vertical-middle-col">
          <Row className="vertical-middle-row">
            <Col className="vertical-middle-col FlightDetailsModal__line--time">{time}</Col>
          </Row>
          <Row className="vertical-middle-row FlightDetailsModal__line--date">
            <Col className="vertical-middle-col">{this.getFormatedDateOrOfFlight(date)}</Col>
          </Row>
        </Col>
        {this.renderCompanyLogoOrAirport(companyLogo, airportName, flight)}
      </Row>
    );
  }

  renderThroughFlight(hasExchangeAirport, lastFlight, index) {
    let flightGroup = this.props.flightGroup;
    
    if (!lastFlight) {
      if (hasExchangeAirport) {
        return (
          <Row className="FlightDetailsModal__throughFlight FlightDetailsModal__throughFlight--red">
            <Col xs={12}>
              <i className="clock-icon atention" title="Clock" />
              <span className="FlightDetailsModal__throughFlight--message">
                {i18n.translate(this.verifyOriginAirportNameAndDestinationAirportName(flightGroup, index),
                  { 
                    time: <strong>{this.calculateWaitingTimes(flightGroup, index)}</strong> 
                  })}
              </span>
            </Col>
          </Row>
        );
      } else {
        return (
          <Row className="FlightDetailsModal__throughFlight">
            <Col xs={12}>
            <i className="clock-icon" title="Clock" />
              <span className="FlightDetailsModal__throughFlight--message">
                {this.verifyIsThroughFlight(index, flightGroup)}
              </span>
            </Col>
          </Row>
        );
      }
    }
  }

  verifyIsThroughFlight(index, flightGroup) {
    const nextFlightIsThrought = flightGroup[index + 1].throughFlight;

    if (flightGroup[index].throughFlight || nextFlightIsThrought) {
      return i18n.translate('components.flightDetailsModal.messageConnection',
        {time: <strong>{this.calculateWaitingTimes(flightGroup, index)}</strong>});
    } else {
      return i18n.translate('components.flightDetailsModal.messageAirplaneChange',
        {time: <strong>{this.calculateWaitingTimes(flightGroup, index)}</strong>});
    }
  }

  verifyOriginAirportNameAndDestinationAirportName(flightgroup, index) {
    const arrivalAirport = flightgroup[index].destination;
    const departureAirport = flightgroup[index + 1].origin;
    let result = '';

    arrivalAirport == departureAirport 
    ? result = 'components.flightDetailsModal.messageAirplaneChange'
    : result = 'components.flightDetailsModal.messageAirportChange';
     
    return result;
  }

  calculateWaitingTimes(flightGroup, index) {
    const format = 'HH:mm';
    const waitingTimes = [];

    for (let i = 0; i < flightGroup.length - 1; i++) {
      const arrivalTime = moment(flightGroup[i].arrivalTime, format);
      const nextDepartureTime = moment(flightGroup[i + 1].departureTime, format);

      let waitingTime = moment.duration(nextDepartureTime.diff(arrivalTime));

      if (waitingTime.asMinutes() < 0) {
        waitingTime = moment.duration(nextDepartureTime.add(1, 'day').diff(arrivalTime));
      }

      const hours = Math.floor(waitingTime.asHours());
      const minutes = waitingTime.minutes();

      if (hours === 0) {
        waitingTimes.push(`${minutes}min`);
      } else {
        waitingTimes.push(`${hours}h ${minutes}min`);
      }
    }

    return waitingTimes[index];
  }

  getOperatingCarrierName(operatingCarrier) {
    if (i18n.translate(`company.${operatingCarrier}`).substring(0, 8) === 'company.') {
      return operatingCarrier;
    } else {
      return i18n.translate('company.' + operatingCarrier);
    }
  }

  renderOperatingByWithLogo(airportNameOrFlight, flight) {
    if (flight.marketingCarrier != flight.operatingCarrier) {
      return (
        <Col className="FlightDetailsModal__line--flightOperatingBy FlightDetailsModal__line--flightNumber">
          <Row className="infoFlights BoldName">{airportNameOrFlight}</Row>
          <Row className="infoFlights BoldName">
            {i18n.translate('components.flightDetailsModal.operatedBy')}
          </Row>
          <Row className="infoFlights">{this.getOperatingCarrierName(flight.operatingCarrier)}</Row>
        </Col>
      );
    } else {
      return <Col className="FlightDetailsModal__line--flightNumber">{airportNameOrFlight}</Col>;
    }
  }

  renderOperatingByWithOutLogo(airportNameOrFlight, flight) {
    if (flight.marketingCarrier != flight.operatingCarrier) {
      return (
        <Col className="FlightDetailsModal__line--flightOperatingBy FlightDetailsModal__line--city vertical-middle-col">
          <Row className="infoFlights BoldName">{airportNameOrFlight}</Row>
          <Row className="infoFlights BoldName">
            {i18n.translate('components.flightDetailsModal.operatedBy')}
          </Row>
          <Row className="infoFlights">{this.getOperatingCarrierName(flight.operatingCarrier)}</Row>
        </Col>
      );
    } else {
      return (
        <Col className="FlightDetailsModal__line--city vertical-middle-col">
          {airportNameOrFlight}
        </Col>
      );
    }
  }

  renderCompanyLogoOrAirport(companyLogo, airportNameOrFlight, flight) {
    if (companyLogo) {
      return (
        <Col
          xs={7}
          md={7}
          lg={9}
          className="FlightDetailsModal__line--city vertical-middle-col text-left">
          <Row>
            <Col xs={6} md={5}>
              <div className={`FlightDetailsModal__line--icon icon-${companyLogo}`} />
            </Col>
            <Col xs={6} md={7}>
              {this.renderOperatingByWithLogo(airportNameOrFlight, flight)}
            </Col>
          </Row>
        </Col>
      );
    } else {
      return (
        <Col xs={7} md={7} lg={9}>
          {this.renderOperatingByWithOutLogo(airportNameOrFlight, flight)}
        </Col>
      );
    }
  }

  renderCircle(darkBlue, companyLogo) {
    if (companyLogo) {
      return (
        <Col className="FlightDetailsModal__squareContainer">
          <div className="FlightDetailsModal__square">
            <div className="flightIcon" />
          </div>
        </Col>
      );
    } else {
      return (
        <Col className="FlightDetailsModal__circleContainer">
          <div
            className={`FlightDetailsModal__circle ${darkBlue ? `FlightDetailsModal__circle${darkBlue}` : ''
              }`}
          />
        </Col>
      );
    }
  }

  renderBackButton() {
    return (
      <Row>
        <Col md={4} lg={4} xsHidden />
        <Col xs={12} md={4} lg={4}>
          <Button
            id="btnBack"
            type="submit"
            className="FlightDetailsModal__button--back"
            onClick={this.props.close}>
            {i18n.translate('components.flightDetailsModal.back')}
          </Button>
        </Col>
        <Col md={4} lg={4} xsHidden />
      </Row>
    );
  }

  renderSelectButton() {
    return (
      <Row className="FlightDetailsModal__button--center">
        <Col xs={12} md={6} lg={6}>
          <Button
            id="btnBack"
            type="submit"
            className="FlightDetailsModal__button--back"
            onClick={this.props.close}>
            {i18n.translate('components.flightDetailsModal.back')}
          </Button>
        </Col>
        <Col xs={12} md={6} lg={6}>
          <Button
            id="btnSelectFlight"
            type="submit"
            className="FlightDetailsModal__button--selectFlight"
            onClick={(e) => this.props.onSelect(this.state.selectPointsPlusMoney)}
          >
            {i18n.translate('components.flightDetailsModal.selectFlight')}
          </Button>
        </Col>
        <Col mdHidden lg={4} xsHidden />
      </Row>
    );
  }

  verifyOriginAirportAndDestinationAirport(flightgroup){
     const origin = flightgroup.some((flights) => ( flights.originAirportName == null));
     const destination = flightgroup.some((flights) => ( flights.destinationAirportName == null));
     
    return origin || destination;
  }
	

  renderButtons() {
    let renderButton;
    if (this.state.featureShowModalSelectionFlightsToggle && this.props.onSelect) {
      renderButton = this.renderSelectButton();
    } else {
      renderButton = this.renderBackButton();
    }
    return renderButton;
  }

  showClassType(classType) {
    if (classType === 'AWARD') return 'Tarifa Award';
    else return 'Tarifa Pública';
  }

  renderModalDetails() {
    return (
      <div>
        <Modal.Header bsClass="FlightDetailsModal__header">
          <Modal.Title>
            {i18n.translate('components.flightDetailsModal.title')}{' '}
            {this.props.isDeparture ? 'ida' : 'volta'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body bsClass="FlightDetailsModal__body">
          {this.renderFlightHeader()}

          {this.renderFlightsGrid()}

          <Row>
            <Col xs={3} md={3} lg={3} className="FlightDetailsModal__line--flightNumber">
              <p>{this.showClassType(this.props.classType)}</p>
            </Col>
            <Col mdHidden lg={3} />
            <Col md={3} lg={3} />
          </Row>

          {this.renderLoading()}
          {this.renderPointsPlusMoney()}

          <div className='FlightDetailsModal__divBordered'>
								<Row>
									<Col sm={1} className='FlightDetail__Logo'>
										<div className="FlightDetail__infoLogo" />
									</Col>
									<Col className="FlightDetailsModal__bagMessage">
										{i18n.translate('components.flightDetailsModal.bagMessage')}
									</Col>
								</Row>
							</div>
          {this.renderButtons()}
        </Modal.Body>
      </div>
    )
  }

  renderPointsPlusMoney() {
    return (
      <PointsPlusMoneyDetailModal        
        id={`pointsPlusMoneyDetailModal-${this.props.id}`}
        onSelectRecomendation={this.props.onSelect}
        prices={this.props.prices}
        cabinCategory={this.props.cabinCategory}
        flight={this.props.flight}
        callbackFinalizeGetPoints={this.callbackFinalizeGetPoints}
        callbackSelectPointsPlusMoney={this.callbackSelectPointsPlusMoney} 
      />)
  }

  callbackFinalizeGetPoints(value) {     
    this.setState({
      finalizeGetPointsPlusMoney: value
    });
  }

  callbackSelectPointsPlusMoney(value) {     
    this.setState({
      selectPointsPlusMoney: value
    });
  }

  renderModalAirportError() {
    return (
      <div>
        <Row>
          <Col xs={3} md={3} lg={3} className="error-airport">
            <div className="modal-error-airport" />
          </Col>
          <Col xs={12} md={6} lg={6} className="FlightDetailsModal__airportNullMessage">
            {i18n.translate('components.flightDetailsModal.messageErrorAriport')}
            <span className='stylePhoneNumber'>
              {i18n.translate('components.flightDetailsModal.contactNumber')}
            </span>
            {i18n.translate('components.flightDetailsModal.otherMessageErrorAriport')}
            <span className='stylePhoneNumber'>
              {i18n.translate('components.flightDetailsModal.ohterContactNumber')}
            </span>
            {i18n.translate('components.flightDetailsModal.finalMessageErrorAriport')}
          </Col>
          <Col xs={6} md={3} lg={3} className='buttonBack'>
            {this.renderBackButton()}
          </Col>
        </Row>
      </div>
    )
  }

  renderModalAirportErrorCallCenter() {
    return (
      <div>
        <Modal.Header bsClass="FlightDetailsModal__header">
          <Modal.Title>
            {i18n.translate('components.flightDetailsModal.title')}{' '}
            {this.props.isDeparture ? 'ida' : 'volta'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body bsClass="FlightDetailsModal__body">
          {this.renderFlightHeader()}
          {this.renderFlightsGrid()}

          <div>
            <Row>
              <Col xs={3} md={3} lg={3} className="error-airport-callCenter">
                <div className="modal-error-airport-callCenter" />
              </Col>
              <Col xs={12} md={6} lg={6} className="FlightDetailsModal__airportNullMessage-callCenter">
                {i18n.translate('components.flightDetailsModal.messageErrorAriport-callCenter')}
              </Col>
              <Col xs={6} md={3} lg={3} className='buttonBack'>
                {this.renderBackButton()}
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </div>
    )
  }

  renderLoading() {
    if (this.props.onSelect && !this.state.finalizeGetPointsPlusMoney)
      return (
        <div className="Spinner" data-unit="loadingSpinner">
          <div>
            <i className="icon-spinner" />
          </div>
        </div>
      );
  }

  render() {
    return (
      <div>
        {this.props.isCallcenterEnabled && isFromCallcenter() ?
          (
            <Modal
              id={`componentModalDetails-${this.props.id}`}
              className="ModalDetail"
              ref={c => (this.modalDetails = c)}
              show={this.props.show}
              onHide={this.props.close}>

              {this.verifyOriginAirportAndDestinationAirport(this.props.flightGroup) !== true ?
                (this.renderModalDetails())
                :
                (this.renderModalAirportErrorCallCenter())
              }
            </Modal>
          )
          :
          (
            <Modal
              id={`componentModalDetails-${this.props.id}`}
              className="ModalDetail"
              ref={c => (this.modalDetails = c)}
              show={this.props.show}
              onHide={this.props.close}>

              {this.verifyOriginAirportAndDestinationAirport(this.props.flightGroup) !== true ?
                (this.renderModalDetails())
                :
                (this.renderModalAirportError())
              }
            </Modal>
          )
        }
      </div>)
  }
}

FlightDetailsModal.propTypes = propTypes;
FlightDetailsModal.defaultProps = defaultProps;

export default FlightDetailsModal;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightDetailsModal/FlightDetailsModal.jsx